/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Milestone from '@linc-technologies/linced-common/models/milestones/milestone';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: milestones.MilestoneSet.
export default class MilestoneSet extends Model {
  declare [Type]: 'milestones/milestone-set';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @hasMany('milestones/milestone', { async: true, inverse: 'setId' })
  declare milestones: AsyncHasMany<Milestone>;

  @attr('string', { defaultValue: '' })
  declare templateId: string;
}
